'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination, Navigation } from 'swiper/modules';
import type { TDynamicData } from '../../types/dynamic-data';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { Button } from '@eliadmin/core/src/components/ui/button';
import Link from '@eliadmin/core/src/components/link';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export const HeroSwiper = ({ slides }: { slides: TDynamicData[] }) => {
  return (
    <Swiper pagination={true} modules={[Pagination, Navigation]} className="mySwiper">
      {slides?.map((slide, index) => (
        <SwiperSlide
          key={slide.slug}
          className="relative flex h-full max-h-[1000px] min-h-[525px] w-full items-center justify-center px-6 pb-[220px] pt-16 sm:min-h-0 md:py-20 lg:py-40"
        >
          <div className="relative z-[4] mx-auto flex w-full max-w-[1280px] flex-col items-start justify-start gap-8">
            <h1 className="w-full max-w-[700px] text-5xl font-bold text-black sm:text-6xl lg:text-7xl">
              {slide.name}
            </h1>
            <Button asChild>
              <Link prefetch={false} href={slide?.fields[1]?.value || '/eshop'}>
                Pozerať produkty
              </Link>
            </Button>
          </div>
          <div
            className={cn(
              'absolute left-0 top-0 z-[2] h-full w-full opacity-50',
              'ea-hero-overlay',
            )}
          />
          {slide?.image && (
            <Image
              src={slide.image?.url}
              alt={resolveImageAlt(slide?.image, undefined)}
              fill
              sizes="100vw"
              priority={index === 0}
              fetchPriority={index === 0 ? 'high' : 'auto'}
              style={{ objectFit: 'cover', objectPosition: 'center' }}
              className="absolute inset-0 z-[1] h-full w-full"
            />
          )}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
